import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Context as PointsContext } from "../../context/PointsContext";
import PointStat from "./PointStat";
import { Button, ButtonGroup } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  statsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    flexWrap: "wrap",
    paddingTop: 2,
    paddingBottom: 4,
    paddingLeft: 3,
    paddingRight: 3,
    margin: 3,
    marginBottom: 8,
    borderRadius: 5,
  },
}));

const PointIndicators = () => {
  const classes = useStyles();
  const {
    state: { claimed, given, validScopes },
    fetchIndicators,
  } = useContext(PointsContext);

  const [scope, setScope] = useState(validScopes[0]);
  const [indicator, setIndicator] = useState(given);

  useEffect(() => {
    if (Object.keys(claimed).length === 0){
        fetchIndicators();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setIndicator(given);
    // eslint-disable-next-line
  }, [given]);

  const handleScopeChange = (sp) => {
    setScope(sp);
    switch (sp) {
      case "otorgados":
        setIndicator(given);
        break;
      case "canjeados":
        setIndicator(claimed);
        break;
      default:
        setIndicator(claimed);
        break;
    }
  };

  const buttonGroup = validScopes.map((sp, index) => (
    <Button
      key={index}
      disabled={sp === scope}
      onClick={() => handleScopeChange(sp)}
    >
      {sp}
    </Button>
  ));

  return (
    <div>
      <ButtonGroup
        variant="contained"
        color="primary"
        aria-label="contained primary button group"
      >
        {buttonGroup}
      </ButtonGroup>
      <div className={classes.statsContainer}>
        <PointStat title={"Día"} score={indicator.daily} />
        <PointStat title={"Mensual"} score={indicator.monthly} />
        <PointStat title={"Todos"} score={indicator.historic} />
      </div>
    </div>
  );
};
export default PointIndicators;
